import PropTypes from 'prop-types';
import { useMemo } from 'react';
import SimpleTable from '../../uikit/simple_table';
import useIsMobile from '../../utils/hooks/useIsMobile';
import { getDateModifiedFormat } from '../../utils/commonUtils';
import { useNavigate } from 'react-router-dom';

const PendingLogisticTable = ({
  data = [],
  isFirst,
  isLast,
  page,
  fetchNextPage,
  fetchPreviousPage,
}) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  console.log(page);
  /* ------------------ Data Transform ------------------ */

  const transformedData = useMemo(
    () =>
      data.map((item) => ({
        category:
          item.inventoryDetails?.inventoryDetailsParent?.inventoryType
            ?.inventoryType || '-',
        subCategory:
          item.inventoryDetails?.inventoryDetailsParent?.inventoryParentName ||
          '-',
        item: item.inventoryDetails?.inventoryName || '-',
        quantity: item.quantity || 0,
        date: item.decisionDate || null,
        raisedBy: item.pmName || '-',
        miId: item.materialIndentId || '-',
      })),
    [data]
  );

  /* ------------------ Desktop Columns ------------------ */

  const columns = useMemo(
    () => [
      {
        accessorKey: 'slNo',
        header: 'SL No',
        cell: ({ row }) => page * 20 + row.index + 1,
        minSize: 40,
        maxSize: 40,
      },
      { accessorKey: 'category', header: 'Category' },
      { accessorKey: 'subCategory', header: 'Sub Category' },
      { accessorKey: 'item', header: 'Item' },
      {
        accessorKey: 'quantity',
        header: 'Quantity',
        cell: (row) => parseFloat(row.getValue() || 0).toLocaleString('en-IN'),
      },
      {
        accessorKey: 'date',
        header: 'Date',
        cell: (row) => getDateModifiedFormat(row.getValue()),
      },
      { accessorKey: 'raisedBy', header: 'Raised By' },
      {
        accessorKey: 'miId',
        header: 'MI ID',
        cell: (row) => (
          <span
            onClick={() =>
              navigate(`/materials-indent/${row.getValue()}/view   `)
            }
            className="font-medium text-blue-600 hover:underline cursor-pointer"
          >
            {row.getValue()}
          </span>
        ),
      },
    ],
    [navigate, page]
  );

  /* ------------------ Mobile Columns ------------------ */

  const mobileColumns = useMemo(
    () => [
      {
        accessorKey: 'miId',
        header: 'MI Details',
        cell: (row) => {
          const item = row.row.original;
          return (
            <div className="space-y-1">
              <div
                className="font-medium text-blue-600 hover:underline cursor-pointer"
                onClick={() => navigate(`/mi/${item.miId}`)}
              >
                MI ID: {item.miId}
              </div>
              <div className="text-sm text-gray-600">
                Category: {item.category}
              </div>
              <div className="text-sm text-gray-600">
                Sub Category: {item.subCategory}
              </div>
              <div className="text-sm text-gray-600">Item: {item.item}</div>
              <div className="text-sm text-gray-600">
                Quantity:{' '}
                {parseFloat(item.quantity || 0).toLocaleString('en-IN')}
              </div>
              <div className="text-sm text-gray-600">
                Date: {getDateModifiedFormat(item.date)}
              </div>
              <div className="text-sm text-gray-600">
                Raised By: {item.raisedBy}
              </div>
            </div>
          );
        },
      },
    ],
    [navigate]
  );

  /* ------------------ Render ------------------ */

  return (
    <SimpleTable
      data={transformedData}
      columns={isMobile ? mobileColumns : columns}
      pageIndex={page}
      isFirst={isFirst}
      isLast={isLast}
      fetchNextPage={fetchNextPage}
      fetchPreviousPage={fetchPreviousPage}
      pageSize={20} //need to match with PAGE_SIZE in usePendingLogistics
    />
  );
};

PendingLogisticTable.propTypes = {
  data: PropTypes.array.isRequired,
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  page: PropTypes.number.isRequired,
  fetchNextPage: PropTypes.func.isRequired,
  fetchPreviousPage: PropTypes.func.isRequired,
};

export default PendingLogisticTable;
